import React from 'react';

const TransferredIcon = ({ size = 16, color = '#8b5cf6' }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 8h8M10 8l-2-2m2 2l-2 2" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="13" cy="8" r="2" fill={color} />
    </svg>
);

export default TransferredIcon;
